import { createSlice } from "@reduxjs/toolkit";

/*
This slice controls global loading states in the application. Each slice handles its own loading
for the most part, but the global load slice triggers some more generic loading effects in the
application. This slice also controls the stepper loader, which gives progress indications to 
the user.
*/

const initialState = {
  isLoading: false,
  isStepperLoad: false,
  stepperValue: 0,
  stepperTitle: null,
  redirect: null,
};

const globalLoadSlice = createSlice({
  name: "globalLoad",
  initialState,
  reducers: {
    startGlobalLoad(state) {
      state.isLoading = true;
    },
    stopGlobalLoad(state) {
      state.isLoading = false;
    },
    setIsStepper(state, action) {
      const { stepBool, stepTitle } = action.payload;
      state.isStepperLoad = stepBool;
      state.stepperTitle = stepTitle;
    },
    updateStepperValue(state, action) {
      const { value } = action.payload;
      state.stepperValue += value;
    },
    resetStepperValue(state) {
      state.stepperValue = 0;
      state.stepperTitle = null;
      state.isStepperLoad = false;
    },
    setRedirect(state, action) {
      const { url } = action.payload;
      state.redirect = url;
    },
  },
});

export const {
  startGlobalLoad,
  stopGlobalLoad,
  setIsStepper,
  updateStepperValue,
  resetStepperValue,
  setRedirect,
} = globalLoadSlice.actions;

export default globalLoadSlice.reducer;
